import { useEffect, useState } from "react";
import ChatWindow from "./ChatWindow";
import { GoogleGenerativeAI } from "@google/generative-ai";
import PROMPT from "./Prompt";
import { parseAIRespose } from "../../utils/parseAIResponse";
import { contact } from "../../utils/contact";
import { containsCSSVariable } from "framer-motion";

const SUGGESTIONS = [
  "What stack do you use?",
  "Tell me about your projects.",
  "Are you available for hire?",
  "What's your background?",
];

export default function MandlaAssistance() {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState("");
  const [messages, setMessage] = useState([
    {
      role: "assistant",
      content:
        "Hey there! I'm MandlaAI assistant. Ask me anything about him, his skills, projects, or experience, summary of his blog posts",
    },
  ]);

  useEffect(() => {
    const timer = setTimeout(() => setOpen(true), 4000);
    return () => clearTimeout(timer);
  }, []);

  const genAI = new GoogleGenerativeAI(
    process.env.REACT_APP_GEMINI_KEY
  );

  const model = genAI.getGenerativeModel({
    model: "gemini-2.5-flash-lite",
    systemInstruction: PROMPT,
  });

  const sendMessage = async (text) => {
    const userText = text || input.trim();
    if (!userText) return;

    const newMessages = [...messages, { role: "user", content: userText }];
    setMessage(newMessages);
    setInput("");

    try {
      const history = messages.slice(1).map((msg) => ({
        role: msg.role === "assistant" ? "model" : "user",
        parts: [{ text: msg.content }],
      }));

      const chat = model.startChat({ history });

      const result = await chat.sendMessage(userText);
      const response = result.response.text();
      const parsed = parseAIRespose(response);

      if (parsed.userData) {
        contact(parsed.userData);
      }

      setMessage((prev) => [...prev, { role: "assistant", content: response }]);
    } catch (error) {
      console.error("Error calling Gemini API:", error);
    }
  };

  return (
    <div className="fixed bottom-[2rem] px-2 right-0 md:right-[2rem] z-50 ">
      {open && (
        <ChatWindow
          messages={messages}
          SUGGESTIONS={SUGGESTIONS}
          input={input}
          setInput={setInput}
          sendMessage={sendMessage}
        />
      )}
      <button
        className="w-[56px] h-[56px] rounded-full flex items-center justify-center shadow-2xl bg-[#978b72]  text-[#ece1cf]"
        onClick={() => setOpen((prev) => !prev)}
      >
        {open ? (
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        ) : (
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
        )}
      </button>
    </div>
  );
}
